"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountIntentSlotSchema = exports.FlowType = exports.lexConditionPattern = exports.branchNamePattern = void 0;
const yup_lib_1 = __importDefault(require("../yup-lib"));
const data_1 = require("@citibot/data");
const LexResourceNamePattern = /^([0-9a-zA-Z][_-]?)+$/;
exports.branchNamePattern = /^Branch\d+$/;
exports.lexConditionPattern = /\{(\w+)\}\s*=\s*"([^"]+)"/;
var FlowType;
(function (FlowType) {
    FlowType["IntentDependent"] = "Intent";
    FlowType["SlotDependent"] = "Slot";
})(FlowType || (exports.FlowType = FlowType = {}));
exports.AccountIntentSlotSchema = yup_lib_1.default.object().shape({
    account: yup_lib_1.default.string().required().label('Account'),
    intentId: yup_lib_1.default.string().required().label('Intent'),
    name: yup_lib_1.default
        .string()
        .matches(LexResourceNamePattern, 'Please enter intent slot name consisting Alphabet, Number, _ & -')
        .required()
        .max(100, 'Must be maximum of 100 character')
        .label('Name'),
    description: yup_lib_1.default.string().optional().min(0).max(200).label('Description'),
    slotTypeName: yup_lib_1.default.string().required().min(1).max(100).label('Slot Type Name'),
    priority: yup_lib_1.default.number().integer().required().min(0).label('Priority'),
    slotConstraint: yup_lib_1.default.string().oneOf(data_1.SlotConstraintOptions).required().label('Slot Constraint'),
    multipleValuesSetting: yup_lib_1.default.boolean().optional().default(false),
    obfuscationSetting: yup_lib_1.default
        .string()
        .oneOf(data_1.ObfuscationSettingsOptions)
        .required()
        .label('Obfuscation Setting'),
    maxRetries: yup_lib_1.default.number().integer().required().min(0).max(5).label('Max Retires'),
    ellicitedMessage: yup_lib_1.default.string().optional().min(1).max(200),
    dependentFlow: yup_lib_1.default.boolean().notRequired().label('Dependent Flow'),
    conditionalBranches: yup_lib_1.default
        .array()
        .when('dependentFlow', {
        is: true,
        then: yup_lib_1.default.array().of(yup_lib_1.default.object().shape({
            condition: yup_lib_1.default
                .string()
                .min(1)
                .max(255)
                .matches(exports.lexConditionPattern, 'Invalid format. Expected format: {slotName} = "value"')
                .required()
                .label('Condition'),
            branchName: yup_lib_1.default
                .string()
                .matches(exports.branchNamePattern, "Invalid format. The value must start with 'Branch' followed by a number (e.g., 'Branch1')")
                .required()
                .label('Branch Name'),
            nextSlot: yup_lib_1.default.string().min(1).required().label('Next Slot'),
            flowType: yup_lib_1.default
                .mixed()
                .oneOf(Object.values(FlowType))
                .default(FlowType.SlotDependent)
                .required()
                .label('Flow Type'),
            intentName: yup_lib_1.default.string().when('flowType', {
                is: FlowType.IntentDependent,
                then: yup_lib_1.default.string().min(1).required().label('Intent Name'),
                otherwise: yup_lib_1.default.string().notRequired()
            })
        })),
        otherwise: yup_lib_1.default.array().notRequired()
    })
        .label('Conditional Branches'),
    defaultBranch: yup_lib_1.default.string().when('dependentFlow', {
        is: true,
        then: yup_lib_1.default.string().min(1).max(255).required().label('Default Branch'),
        otherwise: yup_lib_1.default.string().notRequired()
    })
});
